// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BuildOutlinedSvg from "@ant-design/icons-svg/es/asn/BuildOutlined";
import AntdIcon from '../components/AntdIcon';

var BuildOutlined = function BuildOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BuildOutlinedSvg
  }));
};

BuildOutlined.displayName = 'BuildOutlined';
export default React.forwardRef(BuildOutlined);